import { OwaDate } from 'owa-datetime';
import { action } from 'satcheljs';
import PerfMarker from '../store/schema/PerfMarker';

export const addCard = action('addCard', (cardId: string) => ({
    cardId: cardId,
}));

export const removeCard = action('removeCard', (cardId: string) => ({
    cardId: cardId,
}));

export const setAutoInvokeActionAlreadyRan = action(
    'setAutoInvokeActionAlreadyRan',
    (cardId: string, autoInvokeActionAlreadyRan: boolean) => ({
        cardId: cardId,
        autoInvokeActionAlreadyRan: autoInvokeActionAlreadyRan,
    })
);

export const markPerfCheckpoint = action(
    'markPerfCheckpoint',
    (cardId: string, perfMarker: PerfMarker, time?: OwaDate) => ({
        cardId: cardId,
        perfMarker: perfMarker,
        time: time,
    })
);

export const setTotalFetchTimeForCard = action(
    'setTotalFetchTimeForCard',
    (cardId: string, totalFetchTime: number) => ({
        cardId: cardId,
        totalFetchTime: totalFetchTime,
    })
);

export const updatePerfCheckpointsBeforeAutoInvoke = action(
    'updatePerfCheckpointsBeforeAutoInvoke',
    (cardId: string) => ({
        cardId: cardId,
    })
);
